//#region import
import React from "react";
import { Grid } from "@mui/material";
import { useLocation } from "react-router";
import { I18n } from "utilities/utilities";
import Tabs, { TabContent, TabItem, TabPanel } from "components/Input/Tab";
import PublishDocTable from "./PublishDocTable";
//#endregion

export default function PublishDocList() {
  const location = useLocation();
  const searchParams = location.search;
  const sMode = new URLSearchParams(searchParams).get("sMode");

  return (
    <Grid container spacing={2}>
      <Grid item marginTop={"10px"} xs={12}>
        <Tabs id={"Doc"} defaultTab={!sMode ? "DocMain" : sMode}>
          <TabItem id="DocMain">{`${I18n.SetText(
            "PublishDoc.sDocMain"
          )}`}</TabItem>
          <TabItem id="DocGroup">{`${I18n.SetText(
            "PublishDoc.sDocGroup"
          )}`}</TabItem>
          <TabItem id="DocType">{`${I18n.SetText(
            "PublishDoc.sDocType"
          )}`}</TabItem>
          <TabContent id={"TabContentDoc"}>
            <TabPanel id="DocMain">
              <PublishDocTable sMode="DocMain" />
            </TabPanel>
            <TabPanel id="DocGroup">
              <PublishDocTable sMode="DocGroup" />
            </TabPanel>
            <TabPanel id="DocType">
              <PublishDocTable sMode="DocType" />
            </TabPanel>
          </TabContent>
        </Tabs>
      </Grid>
    </Grid>
  );
}
